import React, { useState } from "react";
import "../style/Mainpage.scss";
import img3 from "../Assets/books.jpg";
import { Link } from "react-router-dom";

const Mainpage = () => {
  const [comingSoonMessage, setComingSoonMessage] = useState("");

  const handleComingSoon = (type) => {
    if (type === "podcasts") {
      setComingSoonMessage("Podcasts are coming soon. Stay tuned!");
    } else if (type === "articles") {
      setComingSoonMessage("Articles are coming soon. Stay tuned!");
    }
  };

  return (
    <div className="pagemp">
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">Welcome to Knowledge Hub</h1>
          <p className="hero-subtitle">Where curiosity meets discovery</p>
        </div>
        <div className="hero-image">
          <img src={img3} alt="Books collection representing knowledge" />
        </div>
      </div>
      
      <div className="content-section">
        <div className="description">
         <p>
  Knowledge Hub is a simple place to discover books. You can search for a book by its name and explore 
  useful information related to it in an easy way.
</p>
<p>
  This platform is for anyone who enjoys learning, whether you are just starting or already curious 
  about many subjects. Everything is kept simple and easy to understand.
</p>
<p>
  In the future, podcasts and articles will be added to make learning more interesting and accessible. 
  Start exploring with Knowledge Hub and grow your knowledge step by step.
</p>
        </div>
        
        <div className="cta-section">
          <div className="cta-options">
            <Link to='/bookstore' className="cta-button">
              <span>📚</span>
              Bookstore
            </Link>
            <button
              type="button"
              className="cta-button cta-button--secondary"
              onClick={() => handleComingSoon("podcasts")}
            >
              <span>🎧</span>
              Podcasts
            </button>
            <button
              type="button"
              className="cta-button cta-button--secondary"
              onClick={() => handleComingSoon("articles")}
            >
              <span>📝</span>
              Articles
            </button>
          </div>

          {comingSoonMessage && (
            <p className="coming-soon-message">{comingSoonMessage}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Mainpage;
